// Owner approval PIN — set by the owner, checked by the database.
//
// The PIN never comes back: own_pin_status() says only whether one exists and
// since when. verify_owner_pin() is not callable from here at all; it runs
// inside void_transaction() on the server.

import { supabase } from '@/lib/supabase';

export interface OwnPinStatus {
  set: boolean;
  setAt: number | null;
}

export async function getOwnPinStatus(): Promise<OwnPinStatus> {
  const { data, error } = await supabase.rpc('own_pin_status');
  if (error) throw new Error(error.message);
  const d = (data ?? {}) as { set?: boolean; setAt?: string | null };
  return { set: !!d.set, setAt: d.setAt ? new Date(d.setAt).getTime() : null };
}

export async function setOwnPin(pin: string): Promise<void> {
  const { error } = await supabase.rpc('set_own_pin', { p_pin: pin });
  if (error) throw new Error(error.message);
}
